/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
import axios from 'axios';
import store from '@/store';
import qs from 'qs';
import Vue from 'vue';
import { Notify, Toast } from 'vant';
import router from '@/router/index';
import { getStorage, setBeforeRegisterUrl } from '@/utils/storage';
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // request timeout
});

service.interceptors.request.use(
  config => {
    const isAdmin = router.currentRoute.query.flag === 'admin';
    const channelNo = router.currentRoute.params.channelNo;
    const storageName = 'channel' + channelNo;
    const channelStorage = getStorage(storageName) || {};
    const token = channelStorage.token;
    // const channelId = channelStorage;
    (!isAdmin && token) && (config.headers['SaasChannelUserToken'] = token);
    if (router.currentRoute.query.flag === 'admin') {
      config.headers['flag'] = 'admin';
    }
    if (config.method == 'get') {
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      // 暂时使用
      let params = config.data || {};
      // 接口有的是channeId .... 就这样吧
      try {
        params.channeId = params.channelId =
          params.channeId || store.state.channel.info.id;
      } catch (error) {}
      params.channelNo = channelNo || params.channelNo;
      // end
      if (!/fileUpload/.test(config.url)) {
        config.data = qs.stringify(params);
      }
    }

    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  response => {
    // return response
    const res = response.data;
    if (res.status == 1) {
      return { ...response, pdata: res.data };
    } else {
      // 管理预览不处理异常
      const isAdmin = router.currentRoute.query.flag === 'admin';
      if(isAdmin){
        return Promise.reject();
      }
      if (res.status == -999 || res.status == -996) {
        // 缓存URL
        setBeforeRegisterUrl();
        // 清空缓存数据
        const channelNo = router.currentRoute.params.channelNo;
        const storageName = 'channel' + channelNo;
        localStorage.removeItem(storageName);
        store.commit('user/SET_INFO', {});
        //去注册
        router
          .replace({
            name: 'register'
          })
          .catch(err => err);
      } else if (res.status == -998) {
        //未完善
        router
          .replace({
            name: 'perfect'
          })
          .catch(err => err);
      } else if (res.status == -997) {
        //需要口令
        router
          .replace({
            name: 'word'
          })
          .catch(err => err);
      } else if ([-995, -994, -993, -992].includes(+res.status)) {
        // 停用 删除 下架 内容下架
        router.replace({
          name: 'stop',
          query: { type: res.status }
        });
      }
      Toast.fail(res.message);
      return Promise.reject(res);
    }
  },
  error => {
    console.log(error, '---');
    return Promise.reject(error);
  }
);

export default service;
